import { contextFactory } from '@frontend/design-system';
import { UseTemplatesV2ProviderResults } from './hooks';

export const [FormTemplatesV2Context, useFormTemplatesV2Context] = contextFactory<UseTemplatesV2ProviderResults>();
